export default "__VITE_ASSET__2zKvdHCk__"